/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_CountryInputs */

const en_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const de_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

const fr_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pays`)
};

const es_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pais`)
};

const it_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paese`)
};

const nl_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

const pl_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraj`)
};

const fi_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maa`)
};

const da_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

const sv_resume_editor_country = /** @type {(inputs: Resume_Editor_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Resume_Editor_CountryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_country = /** @type {((inputs?: Resume_Editor_CountryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_CountryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_country(inputs)
	if (locale === "fr") return fr_resume_editor_country(inputs)
	if (locale === "es") return es_resume_editor_country(inputs)
	if (locale === "it") return it_resume_editor_country(inputs)
	if (locale === "nl") return nl_resume_editor_country(inputs)
	if (locale === "pl") return pl_resume_editor_country(inputs)
	if (locale === "fi") return fi_resume_editor_country(inputs)
	if (locale === "da") return da_resume_editor_country(inputs)
	if (locale === "sv") return sv_resume_editor_country(inputs)
	return en_resume_editor_country(inputs)
});